<template>
    <div id="item_manufacturer_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemManufacturerHeader" v-if="$route.params.id > 0">Update Part Manufacturer</span>
                    <span class="page-title" id="itemManufacturerHeader" v-else>Add Part Manufacturer</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemManufacturerList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-manufacture-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ItemManufacturerForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateItemManufacturerBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateItemManufacturer" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateItemManufacturerBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateItemManufacturer" > 
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueItemManufacturerBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateItemManufacturer(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelItemManufacturerBtn" class="btn btn-tertiary" v-on:click.prevent="BackItemManufacturerList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

 



export default {
  name: "LocationCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Part Manufacture | " +process.env.COPYRIGHT_NAME : "Add Part Manufacture | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    description: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_component_manufacturer' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {

            self.loadItemManufacturer();
            
        }
  },
  methods: {

    BackItemManufacturerList() {
      var self = this;
      self.$router.push("/part-manufacturer/list");
    },

    CreateItemManufacturer(flag) {
      var self = this;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.code_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
      }
      
      if (self.name_error_msg == "" && self.code_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateItemManufacturerBtn").val("Updating ...");
                $("#CreateItemManufacturerBtn").prop("disabled", true);
                $("#cancelItemManufacturerBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueItemManufacturerBtn").val("Saving ...");
                    $("#CreateItemManufacturerBtn").prop("disabled", true);
                    $("#createAndContinueItemManufacturerBtn").prop("disabled", true);
                    $("#cancelItemManufacturerBtn").prop("disabled",true);

                }else{

                    $("#CreateItemManufacturerBtn").val("Saving ...");
                    $("#CreateItemManufacturerBtn").prop("disabled", true);
                    $("#createAndContinueItemManufacturerBtn").prop("disabled", true);
                    $("#cancelItemManufacturerBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/componentmanufacturer/create",
                type: "POST",
                data: {name: self.name, id: segments[3], code: self.code, description: self.description},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateItemManufacturerBtn").val("Update");
                        $("#CreateItemManufacturerBtn").prop("disabled", false);
                        $("#cancelItemManufacturerBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueItemManufacturerBtn").val("Save and Continue");
                            $("#CreateItemManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueItemManufacturerBtn").prop("disabled", false);
                            $("#cancelItemManufacturerBtn").prop("disabled",false);

                        }else{

                            $("#CreateItemManufacturerBtn").val("Save");
                            $("#CreateItemManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueItemManufacturerBtn").prop("disabled", false);
                            $("#cancelItemManufacturerBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ItemManufacturerForm").trigger("reset");
                            self.name ="";
                            self.code = "";
                            self.description = "";
                    
                        }else{
                            self.$router.push("/part-manufacturer/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateItemManufacturerBtn").val("Update");
                        $("#CreateItemManufacturerBtn").prop("disabled", false);
                        $("#cancelItemManufacturerBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ItemManufacturerForm").trigger("reset");
                            

                            $("#createAndContinueItemManufacturerBtn").val("Save and Continue");
                            $("#CreateItemManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueItemManufacturerBtn").prop("disabled", false);
                            $("#cancelItemManufacturerBtn").prop("disabled",false);

                        }else{

                            $("#CreateItemManufacturerBtn").val("Save");
                            $("#CreateItemManufacturerBtn").prop("disabled", false);
                            $("#createAndContinueItemManufacturerBtn").prop("disabled", false);
                            $("#cancelItemManufacturerBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'comp-manu-create')
                }
            });
      }else{
            self.errorValidationFocus();
      }
     
    },

    loadItemManufacturer() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/componentmanufacturer/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                    self.description = data.content.description;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'comp-manu-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ComponentManufacturerCreate.vue